import { render } from "./DisclosuresForm.vue?vue&type=template&id=0b1e2896&scoped=true"
import script from "./DisclosuresForm.vue?vue&type=script&lang=js"
export * from "./DisclosuresForm.vue?vue&type=script&lang=js"

import "./DisclosuresForm.vue?vue&type=style&index=0&id=0b1e2896&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1e2896"]])

export default __exports__